import { componentCheckSize, createMarkup } from "../../../utils/helperServices";
import { CustomContainer, Row, Col } from "../../atoms/DependencyHelper";
import styles from "./UpgradeCard.module.scss";

const UpgradeCard = (props) => {
  const isTablet= componentCheckSize()<992;
  const cardData = props.cardData;
  return (
    <Row  className={styles["upgrade-card"]}>
      <Col md={7} className={styles["upgrade-card__text-container"]}>
        {!isTablet &&(
           <CustomContainer className={styles["card-title"]}>{cardData.title}</CustomContainer>
        )}
       
        <CustomContainer className={styles["card-sub_title"]}>{cardData.subTitle}</CustomContainer>
        <CustomContainer className={styles["card-description"]} dangerouslySetInnerHTML={createMarkup(cardData.description)}></CustomContainer>
      </Col>
      <Col md= {5} className={styles["upgrade-card__image-container"]}><img src={cardData.image} /></Col>
    </Row>
  );
};

export default UpgradeCard;
